<fui-filter-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                   [ngClass]="'clickable'">
    <fui-fixtures>
        <fui-fixture>
            <fui-filter-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                              [title]="label" [valued]="valued"></fui-filter-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        @if (!disabled) {
            <fui-fixture>
                <fui-mark-toggle [toggled]="popped">
                    <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
                </fui-mark-toggle>
            </fui-fixture>
        }
        <fui-spanning-fixture>
            @if (!disabled || !selections || !selections.length || !optionOpenable) {
                <fui-input-dom>
                    <input (blur)="onBlur($event)" #input (focus)="onFocus($event)" [ngModel]="selected"
                           [placeholder]="placeholder | translate" [readonly]="true" [tabindex]="tabindex" type="text">
                </fui-input-dom>
            }
            @if (disabled && selections && selections.length && optionOpenable) {
                <div class="multiselect-links">
                    @for (selection of selections; track selection) {
                        <span class="multiselect-links-link">
              <span class="multiselect-links-link-text"
                    (click)="openOption($event, selection)">{{ selection[key] }}</span>
            </span>
                    }
                </div>
            }
        </fui-spanning-fixture>
    </fui-fixtures>
</fui-filter-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop($event)">
    <fui-sections>
        @if (loading && !query) {
            <fui-content-section>
                <fui-loading>
                    <fui-ellipsis-loader></fui-ellipsis-loader>
                </fui-loading>
            </fui-content-section>
        }
        <ng-content select="fui-content-section"></ng-content>
        @if (searchable()) {
            <fui-fab-section>
                <fui-search-control [label]="'fui.select-control.label.filter' | translate" [(ngModel)]="query"
                                    id="filter"
                                    [placeholder]="'fui.select-control.placeholder.filter' | translate"></fui-search-control>
            </fui-fab-section>
        }
        @if (filled(selections)) {
            <fui-list-section>
                <fui-multiselect-options [field]="field" [key]="key" [filteredOptions]="selections" id="selections"
                                         [optionOpenable]="optionOpenable"
                                         (optionOpened$)="optionOpened$.emit($event)"
                                         (changeSelections$)="select($event)">
                    <fui-clear-button [title]="'fui.select-control.label.clearSelected'"
                                      (click)="clearSelection($event)"></fui-clear-button>
                </fui-multiselect-options>
            </fui-list-section>
        }
        @if (empty(filteredOptions) && empty(selections)) {
            <fui-content-section>
                <fui-empty>
                    <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
                </fui-empty>
            </fui-content-section>
        }
        @if (filled(filteredOptions)) {
            <fui-section>
                <fui-multiselect-options [field]="field" [key]="key" [filteredOptions]="filteredOptions" id="options"
                                         [optionOpenable]="optionOpenable"
                                         (optionOpened$)="optionOpened$.emit($event)"
                                         [allowLabelMarkup]="allowLabelMarkup"
                                         (changeSelections$)="select($event)"></fui-multiselect-options>
            </fui-section>
        }
        @if (ftb()) {
            <fui-ftb-section>
                <fui-fragments>
                    @if (addable || (options.length > 0 && extendable)) {
                        <fui-fragment>
                            <fui-buttons>
                                @if (options.length > 0 && extendable) {
                                    <fui-mark-button (click)="extend()"
                                                     [attr.title]="'fui.common.button.search' | translate"
                                                     id="extended-search-button">
                                        <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
                                    </fui-mark-button>
                                }
                                @if (addable) {
                                    <fui-mark-button (click)="add()"
                                                     [attr.title]="'fui.common.button.addNew' | translate"
                                                     id="add-new-button">
                                        <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                                    </fui-mark-button>
                                }
                            </fui-buttons>
                        </fui-fragment>
                    }
                    @if (filled(options)) {
                        <fui-fragment>
                            <fui-limit-total [limit]="filteredOptions.length" [total]="total"></fui-limit-total>
                        </fui-fragment>
                    }
                </fui-fragments>
            </fui-ftb-section>
        }
    </fui-sections>
</fui-select-pop>
